import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  AdditionalTechnologyDescription,
  TechnologyDescription,
  TechnologyHeading,
} from '../../components/UI';
import './OurTechnologies.css';
import axios from 'axios';
import { Skeleton } from 'antd';
import { Helmet } from 'react-helmet';

const OurTechnologies = () => {
  const [data, setData] = useState(null);
  const [individualService, setIndividualService] = useState(null);

  const { title } = useParams();

  // const pageTitle = title.replace(/\s+/g, '-').toLowerCase();
  // console.log(pageTitle);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_KEY}/stack`).then(res => {
      setData(res.data);
    });
  }, []);

  // console.log(data);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_KEY}/additional-services`)
      .then(res => {
        setIndividualService(res.data);
      });
  }, []);
  return (
    <>
      {data &&
        data
          .filter(
            filteredData =>
              filteredData.title.replace(/\s+/g, '-').toLowerCase() === title
          )
          .map(e => (
            <Helmet key={e._id}>
              <title>{e.title}</title>
              <meta
                name='description'
                content='AITC is an amazing IT company with technical and experienced professionals who have extensive experience in providing software and services on a global scale.'
                data-react-helmet='true'
              />
              <meta
                name='keywords'
                content='Business software development companies ,software development company,outsourcing software development companies, offshore software development, software outsourcing company, software outsourcing companies in uae, software outsourcing companies in usa, software outsourcing companies in australia, software outsourcing companies in Nepal, software projects outsourcing companies in australia, software projects outsourcing companies in Nepal, software projects outsourcing companies in usa, software projects outsourcing companies in Nepal, it outsourcing companies in uae, it outsourcing companies in usa, it outsourcing companies in Nepal, it outsourcing companies in australia, software development companies in usa, software development companies in uae, software development companies in Nepal, software development companies in australia, software companies, it companies dubai uae, mobile app development companies in uae, mobile app development companies in usa, mobile app development companies in australia, mobile app development companies in Nepal, mobile application development companies in uae, mobile application development companies in usa, mobile application development companies in Nepal, mobile application development companies in australia, best software development companies in uae, android application development companies in usa, mobile app development companies, app development companies india, software development, web application development, web development company, software outsourcing, business solutions, app development companies, mobile application development, android app development, school software solutions, it companies, software development dubai, software development uae'
                data-react-helmet='true'
              />

              <meta
                property='og:image'
                content='https://demo.aitcentre.com/logo512.png'
                data-react-helmet='true'
              />
            </Helmet>
          ))}

      {data === null ? (
        <div className='container'>
          <div
            className='loading-wrapper'
            style={{ width: '100%', height: '90vh', marginTop: '7%' }}
          >
            <Skeleton active />
            <Skeleton active style={{ marginTop: '7%' }} />
            <Skeleton active style={{ marginTop: '7%' }} />
          </div>
        </div>
      ) : (
        data
          .filter(
            filteredData =>
              filteredData.title.replace(/\s+/g, '-').toLowerCase() === title
          )
          .map(e => (
            <div className='technology-page' key={e._id}>
              <TechnologyHeading
                key={e.id}
                first_title={e.title.split(' ')[0]}
                second_title={e.title.split(' ').slice(1)}
                subTitle={e.subTitle}
                bgImg={`${process.env.REACT_APP_API_KEY_WITHOUT_V1}/${e.HeaderBackground}`}
                technologyIllustration={`${process.env.REACT_APP_API_KEY_WITHOUT_V1}/${e.HeaderImg}`}
              />
              <TechnologyDescription
                key={e._id}
                first_title={e.title}
                second_title={e.second_title}
                description={e.description}
                bgImg={`${process.env.REACT_APP_API_KEY_WITHOUT_V1}/${e.descriptionBackground}`}
                list={e.list}
              />
              <div className='additional-tech'>
                <div className='AdditionalTechnologyDescription ant-row'>
                  <div className='AdditionalTechnologyDescription_wrapper container'>
                    {individualService &&
                      individualService
                        .filter(data => data.parentId === e._id)
                        .map(i => (
                          <AdditionalTechnologyDescription
                            title={i.title}
                            key={i._id}
                            description={i.description}
                            imagePlayer={i?.image}
                          />
                        ))}
                  </div>
                </div>
              </div>
            </div>
          ))
      )}
    </>
  );
};

export default OurTechnologies;
